<ng-container *ngIf="configValue">
    <!-- <app-icon *ngIf="configValue.dismissable" name="xmark" type="solid" (click)="dismiss()" /> -->
    <!-- hjälp: close funkar inte... -->
    <span class="material-symbols-rounded close" aria-label="Close" *ngIf="configValue.dismissable" click="dismiss()">
        close
    </span>
    <div class="alert-content">
        <h4 *ngIf="title">
            <span class="material-symbols-rounded" aria-hidden="true"> {{ icon }} </span>
            {{ title }}
        </h4>
        <p *ngIf="message">
            {{ message }}
        </p>
    </div>
    <div #progressBar class="progress-bar" [ngClass]="toastClass" *ngIf="showProgressBar"></div>
    <div class="spinner" *ngIf="showSpinner"></div>
</ng-container>
